import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../App.scss';

const Home: React.FC = () => {
  return (
    <div className="page-container">
      <div className="hero-container">
        <h1 className="hero-title">Math Explorer</h1>
      </div>
      
      <div className="page-content">
        <p className="intro" style={{ textAlign: 'center' }}>
          A fun and interactive way for kids to learn and practice mathematics.
        </p>
        
        <div className="cards-container">
        <div className="card">
            <h2>Length Units Game</h2>
            <p>Practice your understanding of length units by guessing the correct unit of measurement for various objects.</p>
            <Link to="/length-units">
              <button>Play Length Units Game</button>
            </Link>
          </div>

          <div className="card">
            <h2>Practice Math Operations!</h2>
            <p>Practice addition, subtraction, multiplication, and division. Choose which operations to practice and level up as you improve!</p>
            <Link to="/math-operations">
              <button>Play Math Operations</button>
            </Link>
          </div>

          <div className="card">
            <h2>Learn Multiplication Tables</h2>
            <p>Learn and practice multiplication tables from 1 to 12.</p>
            <Link to="/multiplication-tables">
              <button>Start Learning</button>
            </Link>
          </div>
          
          <div className="card">
            <h2>Learn Calculus Operations</h2>
            <p>Master addition, subtraction, multiplication, and division with step-by-step tutorials.</p>
            <Link to="/basic-operations">
              <button>View Tutorials</button>
            </Link>
          </div>
          
         
        </div>
        
        <div className="features-card">
          <h2>Why Math Explorer?</h2>
          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">🎮</span>
              <span className="feature-text">Fun and interactive learning experience</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📚</span>
              <span className="feature-text">Comprehensive tutorials with examples</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🏆</span>
              <span className="feature-text">Learn at your own pace</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🧩</span>
              <span className="feature-text">Visual aids to understand concepts better</span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home; 